<template>
  <div class="card shadow-none mb-1 box-comment">
    <div class="card-header p-1">
      <h3 class="card-title font-weight-bolder font-be-vietnam">
        <b-icon
          icon="chat-left-dots-fill"
          scale="1"
          variant="info"
        /> Bình Luận ({{ total }})
      </h3>
      <span
        v-b-modal.feedback
        class="feedback text-danger"
      ><font-awesome-icon icon="fa-reply" /> Phản hồi</span>
    </div>
    <div class="card-body p-1">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-media>
          <template #aside>
            <b-avatar
              size="50"
              :src="userData.avatar"
              :text="avatarText(userData.full_name)"
              variant="light-primary"
              class="badge-minimal"
              badge-variant="success"
            >
              <feather-icon
                v-if="defaultAvatar(userData.avatar) === ''"
                icon="UserIcon"
                size="22"
              />
            </b-avatar>
          </template>
          <div class="frmComment">
            <b-form-textarea
              v-model="frmData.content"
              v-autogrow
              class="frm_content"
              placeholder="Ý kiến của bạn"
              @input="handleTextArea"
              @focus="updateForm"
            />
            <b-button
              v-if="frmData.show_parent"
              variant="danger"
              class="btn-icon btn-sm"
              @click="onSubmit(article_id)"
            >Gửi <feather-icon icon="SendIcon" /></b-button>
          </div>
        </b-media>
      </b-overlay>
    </div>
    <div
      v-if="items.length > 0"
      class="card-footer p-1 border-0"
    >
      <b-media
        v-for="(item) in items "
        :key="item.id"
      >
        <template #aside>
          <b-avatar
            size="50"
            :src="item.avatar"
            :text="avatarText(item.full_name)"
            variant="light-primary"
            class="badge-minimal"
            badge-variant="success"
          />
        </template>
        <h5 class="mt-0">
          {{ item.full_name }}
        </h5>
        <b-card-text class="mb-0">
          {{ item.content }}
        </b-card-text>
        <div class="block_like_web">
          <span
            v-if="item.is_liked == false"
            class="link_thich"
            @click="onLike(item.id, 'liked')"
          ><font-awesome-icon icon="fa-thumbs-up" /> Thích</span>
          <span
            v-else
            class="link_thich"
            style="color: #C92A57;"
            @click="onLike(item.id, 'unliked')"
          ><strong>Bỏ thích</strong></span>
          <span
            class="link_reply"
            @click="onReply(item.id)"
          ><font-awesome-icon icon="fa-reply" /> Trả lời</span>
          <span class="time-com">{{ item.timeago }}</span>
        </div>
        <comment-sub
          :item="item"
          :frm-sub="frmSub"
        />
      </b-media>
      <p
        v-if="more_loading"
        class="loadMore"
      >
        <a href="javascript:void(0)">
          <b-spinner small /> Loading... </a>
      </p>
      <div v-else>
        <p
          v-if="last_page > currentPage"
          class="loadMore"
        >
          <a
            href="javascript:void(0)"
            @click="loadMore"
          >Xem thêm ý kiến</a>
        </p>
      </div>
    </div>
    <b-modal
      id="feedback"
      no-close-on-backdrop
      title="Phản hồi tin bài"
      hide-footer
    >
      <feedback
        :article_id="article_id"
        @updateFeedback="handleFeedback"
      />
    </b-modal>
  </div>
</template>
<script>
import {
  BSpinner,
  BAvatar,
  BMedia,
  BButton,
  BCardText,
  BFormTextarea,
  BOverlay,
} from 'bootstrap-vue';
import { ref } from '@vue/composition-api'
import { TextareaAutogrowDirective } from 'vue-textarea-autogrow-directive'
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faThumbsUp, faReply } from '@fortawesome/free-solid-svg-icons';
import { showToast, useRouter, defaultAvatar } from '@/@core/utils/utils';
import store from '@/store';
import useJwt from '@/auth/jwt/useJwt';

import { avatarText } from '@core/utils/filter'
import CommentSub from './CommentSub.vue';
import Feedback from './Feedback.vue'

library.add(faThumbsUp, faReply);

export default {
  components: {
    BButton,
    BMedia,
    BCardText,
    BFormTextarea,
    BOverlay,
    BAvatar,
    FontAwesomeIcon,
    BSpinner,
    CommentSub,
    Feedback,
  },
  directives: {
    autogrow: TextareaAutogrowDirective,
  },
  props: {
    articleId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      avatarText,
      defaultAvatar,
      selected: '',
      isOpen: false,
      frmSub: {
        parent_id: '',
        content: '',
        article_id: '',
        show_sub: false,
      },
    }
  },

  setup(props, context) {
    const userData = useJwt.getUser()
    const { route } = useRouter();
    const showLoadMore = ref(true)
    const content = ref('')
    const btnShow = ref(false)
    const loading = ref(false)
    const updated_at = ref('');
    const currentPage = ref(1)
    const perPage = ref(10)
    const last_page = ref(0)
    const parent_id = ref('')
    const more_loading = ref(false)
    const total = ref(0)
    const items = ref([])
    // const article_id = route.value.params.id;
    const article_id = props.articleId;
    const blank = {
      parent_id: '',
      content: '',
      article_id: '',
      show_sub: false,
      show_parent: false,
    }
    const frmData = ref(JSON.parse(JSON.stringify(blank)))
    const resetItemData = () => {
      frmData.value = JSON.parse(JSON.stringify(blank))
    }
    if (article_id) {
      frmData.value.article_id = article_id
      const fechData = () => {
        store.dispatch('comment/fetchData', {
          article_id,
          page: currentPage.value,
          perPage: perPage.value,
          updated_at: updated_at.value,
          parent_id: parent_id.value,
        }).then(response => {
          const result = response.data;
          if (result.code == 200) {
            items.value = result.data.data;
            last_page.value = result.data.last_page
            total.value = result.data.total
          } else {
            showToast(result.message)
          }
        })
      }
      fechData()
    }
    return {
      content,
      btnShow,
      loading,
      items,
      userData,
      article_id,
      total,
      frmData,
      resetItemData,
      showLoadMore,
      currentPage,
      last_page,
      more_loading,
    }
  },
  methods: {
    handleFeedback() {
      this.$bvModal.hide('feedback')
    },
    onLike(id) {
      store.dispatch('comment/like', id)
        .then(response => {
          const result = response.data
          if (result.code == 200) {
            this.items = this.items.map(val => {
              if (val.id == id) {
                val.is_liked = result.data.is_liked
              }
              return val;
            })
          } else {
            showToast(result.message)
          }
        })
    },
    onReply(parent_id) {
      this.frmSub = {
        parent_id: '',
        content: '',
        show_child: false,
        article_id: this.article_id,
      }
      this.items = this.items.map(val => {
        if (val.id == parent_id && val.show_sub == false) {
          val.show_sub = true
        } else {
          val.show_sub = false;
        }
        return val;
      })
      this.frmData.content = '';
      this.frmData.show_parent = false;
    },
    updateForm() {
      this.frmData.content = '';
      this.frmData.show_child = false;
      this.frmData.parent_id = ''
    },
    handleTextArea() {
      this.frmData.show_parent = !!(this.frmData.content)
    },
    onSubmit(article_id) {
      this.loading = true
      const content = (this.frmData.parent_id) ? this.frmData.sub_content : this.frmData.content
      if (article_id && content) {
        const commentForm = {
          parent_id: this.frmData.parent_id,
          content,
          article_id,
        }
        store.dispatch('comment/create', commentForm).then(response => {
          const result = response.data;
          this.loading = false
          if (result.code == 200) {
            this.total++
            this.items.unshift(result.data)
            this.resetItemData()
            showToast(result.message, { variant: 'success' })
          } else {
            showToast(result.message);
          }
        })
      } else {
        showToast('Nhập nội dung bình luận trước khi gủi.')
      }
    },
    loadMore() {
      this.more_loading = true;
      this.currentPage++
      store.dispatch('comment/fetchData', {
        page: this.currentPage,
        article_id: this.article_id,
      }).then(response => {
        const result = response.data;
        if (result.code == 200) {
          this.items = [...this.items, ...result.data.data]
        } else {
          showToast(result.message)
        }
        this.more_loading = false;
      })
    },
  },
}
</script>
